import { jsx, jsxs } from "react/jsx-runtime";
import { Spacer, FormField, AdornedInput, Input, Adornment, FormHelp, Flex, Label, TextButton } from "@zillow/constellation";
import InputMask from "inputmask";
import React, { useRef, useEffect, useCallback } from "react";
import { useFormContext, useFormState } from "react-hook-form";
import { sendTextButtonInteractionEvent } from "../../utils/clickstream/MortgageCalculatorClickstream.esm.js";
import FieldTooltip from "./FieldTooltip.esm.js";
function TextField({
  label,
  leftAdornment,
  rightAdornment,
  name,
  config,
  description,
  textButtonName,
  onChange,
  onBlur,
  autoComplete,
  format,
  type,
  // This just adds a red asteriks, it does not deal with validation.
  required,
  textInputRef,
  textButtonInteractionEventInfo,
  tooltip,
  placeholder,
  disabled,
  textButtonHref,
  // This should be the argument to InputMask, there is a Typescript defintion for
  // it. For docs on usage see https://github.com/RobinHerbots/Inputmask#usage
  mask
}) {
  var _a;
  const form = useFormContext();
  const proxyFormState = useFormState();
  const error = (_a = proxyFormState == null ? void 0 : proxyFormState.errors[name]) == null ? void 0 : _a.message;
  const field = form.register(name, config);
  const inputRef = useRef(null);
  useEffect(() => {
    if (format) {
      const defaultValue = form.getValues(name);
      if (defaultValue) {
        inputRef.current.value = format(defaultValue);
      }
    }
  }, []);
  return /* @__PURE__ */ jsx(Spacer, { marginBottom: "xs", children: /* @__PURE__ */ jsx(FormField, { disabled, label: /* @__PURE__ */ jsxs(Flex, { display: "flex", alignItems: "center", marginBottom: "xxs", children: [
    /* @__PURE__ */ jsx(Label, { children: label }),
    tooltip && /* @__PURE__ */ jsx(FieldTooltip, { ...tooltip }),
    textButtonName ? /* @__PURE__ */ jsx(Flex, { display: "flex", justifyContent: "space-between", marginLeft: "auto", children: /* @__PURE__ */ jsx(TextButton, { as: "a", target: "_blank", rel: "nofollow", href: textButtonHref, onClick: () => textButtonInteractionEventInfo ? sendTextButtonInteractionEvent(textButtonInteractionEventInfo) : "", children: textButtonName }) }) : ""
  ] }), required, description: /* @__PURE__ */ jsx(FormHelp, { error: Boolean(error), children: error || description || /* @__PURE__ */ jsx(React.Fragment, { children: " " }) }), control: /* @__PURE__ */ jsx(AdornedInput, { error: Boolean(error), leftAdornment: leftAdornment && /* @__PURE__ */ jsx(Adornment, { children: leftAdornment }), rightAdornment: rightAdornment && /* @__PURE__ */ jsx(Adornment, { children: rightAdornment }), input: /* @__PURE__ */ jsx(
    Input,
    {
      ...field,
      type: type || "text",
      placeholder,
      onBlur: (e) => {
        field.onBlur(e);
        onBlur == null ? void 0 : onBlur(e);
      },
      onChange: (e) => {
        field.onChange(e);
        onChange == null ? void 0 : onChange(e);
      },
      onInput: format ? (e) => {
        e.target.value = format(e.target.value);
      } : void 0,
      ref: useCallback((el) => {
        if (typeof textInputRef === "function") {
          textInputRef(el);
        } else if (typeof textInputRef === "object" && textInputRef) {
          textInputRef.current = el;
        }
        if (el && mask) {
          const masker = new InputMask(mask);
          masker.mask(el);
        }
        inputRef.current = el;
        field.ref(el);
      }, []),
      autoComplete
    }
  ) }) }) });
}
export {
  TextField as default
};
